import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import ScrollToTop from './components/ScrollToTop';
import VehicleDetails from './pages/VehicleDetails';
import 'flatpickr/dist/flatpickr.min.css';
import './index.css';
import './styles/styles.css';
import posthog from 'posthog-js';

// ✅ Initialize PostHog
posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: 'https://us.i.posthog.com',
  autocapture: false,
});

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("tensor-auth-token")
  );

  useEffect(() => {
    if (isLoggedIn) {
      // ✅ Identify user when logged in
      const userEmail = localStorage.getItem("user-email"); // or however you store it
      const userId = localStorage.getItem("user-id"); // optional

      posthog.identify(userId || userEmail, {
        email: userEmail,
      });
    } else {
      posthog.reset(); // ✅ Clears session if logged out
    }
  }, [isLoggedIn]);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Login setIsLoggedIn={setIsLoggedIn} />} />

        {isLoggedIn ? (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/vehicle/:id" element={<VehicleDetails />} />
          </>
        ) : (
          <>
            <Route path="/dashboard" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default App;
